import React from 'react';
import { Trans } from '@lingui/react';
import { FormattedMarkdown } from '@qover/react-intl';
import { DiscountCodeButton } from './discountForm.styles';

export default {
  actionLabel: <Trans id="discountBar.actionLabel" />,
  addDiscount: <Trans id="discountBar.addDiscount" />,
  discount: <Trans id="discountBar.discount" />,
  error: <Trans id="discountBar.error" />,
  invalidDiscount: <Trans id="discountBar.invalidDiscount" />,
  removeDiscount: (
    discountCode: string,
    removeDiscount: React.DOMAttributes<HTMLAnchorElement>['onClick'],
  ) => (
    <FormattedMarkdown
      id="discountBar.removeDiscount"
      defaults="discountBar.removeDiscount [link](#)"
      options={{
        overrides: {
          a: () => (
            <DiscountCodeButton
              onClick={removeDiscount}
              style={{ textDecoration: 'underline' }}
            >
              {discountCode}
            </DiscountCodeButton>
          ),
        },
      }}
    />
  ),
};
